"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTANTS = void 0;
_Object$defineProperty(exports, "CaptchaError", {
  enumerable: true,
  get: function get() {
    return _captchaError.default;
  }
});
_Object$defineProperty(exports, "DisplaySurface", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.DisplaySurface;
  }
});
_Object$defineProperty(exports, "FacingMode", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.FacingMode;
  }
});
_Object$defineProperty(exports, "IntentToJoinError", {
  enumerable: true,
  get: function get() {
    return _intentToJoin.default;
  }
});
_Object$defineProperty(exports, "JoinMeetingError", {
  enumerable: true,
  get: function get() {
    return _joinMeeting.default;
  }
});
_Object$defineProperty(exports, "JoinWebinarError", {
  enumerable: true,
  get: function get() {
    return _joinWebinarError.default;
  }
});
_Object$defineProperty(exports, "LocalCameraStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalCameraStream;
  }
});
_Object$defineProperty(exports, "LocalCameraStreamEventNames", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalCameraStreamEventNames;
  }
});
_Object$defineProperty(exports, "LocalDisplayStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalDisplayStream;
  }
});
_Object$defineProperty(exports, "LocalMicrophoneStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalMicrophoneStream;
  }
});
_Object$defineProperty(exports, "LocalMicrophoneStreamEventNames", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalMicrophoneStreamEventNames;
  }
});
_Object$defineProperty(exports, "LocalStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalStream;
  }
});
_Object$defineProperty(exports, "LocalStreamEventNames", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalStreamEventNames;
  }
});
_Object$defineProperty(exports, "LocalSystemAudioStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.LocalSystemAudioStream;
  }
});
_Object$defineProperty(exports, "Meeting", {
  enumerable: true,
  get: function get() {
    return _meeting.default;
  }
});
_Object$defineProperty(exports, "MeetingInfoUtil", {
  enumerable: true,
  get: function get() {
    return _utilv.default;
  }
});
exports.MeetingInfoV2 = void 0;
_Object$defineProperty(exports, "PasswordError", {
  enumerable: true,
  get: function get() {
    return _passwordError.default;
  }
});
_Object$defineProperty(exports, "PermissionError", {
  enumerable: true,
  get: function get() {
    return _permission.default;
  }
});
_Object$defineProperty(exports, "PresetCameraConstraints", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.PresetCameraConstraints;
  }
});
exports.REACTIONS = void 0;
_Object$defineProperty(exports, "ReclaimHostEmptyWrongKeyError", {
  enumerable: true,
  get: function get() {
    return _reclaimHostRoleErrors.ReclaimHostEmptyWrongKeyError;
  }
});
_Object$defineProperty(exports, "ReclaimHostIsHostAlreadyError", {
  enumerable: true,
  get: function get() {
    return _reclaimHostRoleErrors.ReclaimHostIsHostAlreadyError;
  }
});
_Object$defineProperty(exports, "ReclaimHostNotAllowedError", {
  enumerable: true,
  get: function get() {
    return _reclaimHostRoleErrors.ReclaimHostNotAllowedError;
  }
});
_Object$defineProperty(exports, "ReclaimHostNotSupportedError", {
  enumerable: true,
  get: function get() {
    return _reclaimHostRoleErrors.ReclaimHostNotSupportedError;
  }
});
_Object$defineProperty(exports, "RemoteMedia", {
  enumerable: true,
  get: function get() {
    return _remoteMedia.RemoteMedia;
  }
});
_Object$defineProperty(exports, "RemoteStreamEventNames", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.RemoteStreamEventNames;
  }
});
_Object$defineProperty(exports, "StreamEventNames", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.StreamEventNames;
  }
});
_Object$defineProperty(exports, "TriggerProxy", {
  enumerable: true,
  get: function get() {
    return _triggerProxy.default;
  }
});
_Object$defineProperty(exports, "createCameraAndMicrophoneStreams", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createCameraAndMicrophoneStreams;
  }
});
_Object$defineProperty(exports, "createCameraStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createCameraStream;
  }
});
_Object$defineProperty(exports, "createDisplayMedia", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createDisplayMedia;
  }
});
_Object$defineProperty(exports, "createDisplayStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createDisplayStream;
  }
});
_Object$defineProperty(exports, "createDisplayStreamWithAudio", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createDisplayStreamWithAudio;
  }
});
_Object$defineProperty(exports, "createMicrophoneStream", {
  enumerable: true,
  get: function get() {
    return _mediaHelpers.createMicrophoneStream;
  }
});
exports.sdkAnnotationTypes = exports.default = void 0;
var _webexCore = require("@webex/webex-core");
var _meetings = _interopRequireDefault(require("./meetings"));
var _config = _interopRequireDefault(require("./config"));
var _interceptors = require("./interceptors");
var _captchaError = _interopRequireDefault(require("./common/errors/captcha-error"));
var _intentToJoin = _interopRequireDefault(require("./common/errors/intent-to-join"));
var _passwordError = _interopRequireDefault(require("./common/errors/password-error"));
var _permission = _interopRequireDefault(require("./common/errors/permission"));
var _joinWebinarError = _interopRequireDefault(require("./common/errors/join-webinar-error"));
var _reclaimHostRoleErrors = require("./common/errors/reclaim-host-role-errors");
var _meeting = _interopRequireDefault(require("./meeting"));
var _utilv = _interopRequireDefault(require("./meeting-info/utilv2"));
var _joinMeeting = _interopRequireDefault(require("./common/errors/join-meeting"));
var _mediaHelpers = require("@webex/media-helpers");
var _CONSTANTS = _interopRequireWildcard(require("./constants"));
exports.CONSTANTS = _CONSTANTS;
var _REACTIONS = _interopRequireWildcard(require("./reactions/reactions"));
exports.REACTIONS = _REACTIONS;
var _sdkAnnotationTypes = _interopRequireWildcard(require("./annotation/annotation.types"));
exports.sdkAnnotationTypes = _sdkAnnotationTypes;
var _MeetingInfoV = _interopRequireWildcard(require("./meeting-info/meeting-info-v2"));
exports.MeetingInfoV2 = _MeetingInfoV;
var _remoteMedia = require("./multistream/remoteMedia");
var _triggerProxy = _interopRequireDefault(require("./common/events/trigger-proxy"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-env browser */

(0, _webexCore.registerPlugin)('meetings', _meetings.default, {
  config: _config.default,
  interceptors: {
    LocusRetryStatusInterceptor: _interceptors.LocusRetryStatusInterceptor.create
  }
});
var _default = exports.default = _meetings.default;
//# sourceMappingURL=index.js.map
